import React from 'react';
import TestimonialCard from '../components/TestimonialCard';
import CallToAction from '../components/CallToAction';

const TestimonialsPage: React.FC = () => {
  const testimonials = [
    {
      name: 'Jennifer K.',
      location: 'Orlando, FL',
      testimonial: 'Splash Right has been maintaining our pool for over a year now and we couldn\'t be happier. Professional, on time, and our pool has never looked better! They\'re always willing to answer my questions and give helpful advice.',
      rating: 5,
      date: 'March 2025'
    },
    {
      name: 'Michael T.',
      location: 'Winter Park, FL',
      testimonial: 'After trying several other pool companies, we found Splash Right and they\'re fantastic. Their attention to detail and customer service is outstanding. I especially appreciate their consistent communication and dependability.',
      rating: 5,
      date: 'February 2025'
    },
    {
      name: 'Sarah L.',
      location: 'Kissimmee, FL',
      testimonial: 'We use their short-term rental service for our Airbnb property. They\'re reliable and our guests always comment on how clean the pool is! Working with a company that understands vacation rental needs has been a game-changer.',
      rating: 4,
      date: 'January 2025'
    },
    {
      name: 'Robert J.',
      location: 'Lake Mary, FL',
      testimonial: 'When I came back from vacation to find my pool was green, I called Splash Right for their green-to-clean service. Within days, my pool was crystal clear again. Their team worked efficiently and kept me updated throughout the process.',
      rating: 5,
      date: 'December 2024'
    },
    {
      name: 'Amy W.',
      location: 'Windermere, FL',
      testimonial: 'I\'ve been using Splash Right for weekly pool maintenance for six months now. Their technicians are knowledgeable, friendly, and always leave my pool looking perfect. I appreciate their consistent service and attention to detail.',
      rating: 5,
      date: 'November 2024'
    },
    {
      name: 'David M.',
      location: 'Winter Garden, FL',
      testimonial: 'Splash Right repaired our pool pump and installed a new salt system. Their expertise was evident, and they completed the work quickly and professionally. Everything was explained clearly, and the price was fair.',
      rating: 5,
      date: 'October 2024'
    },
    {
      name: 'Lisa P.',
      location: 'Oviedo, FL',
      testimonial: 'We switched to Splash Right after being disappointed with another company. The difference in service quality is night and day! Our pool looks amazing, and their bi-weekly service is perfect for our needs and budget.',
      rating: 4,
      date: 'September 2024'
    },
    {
      name: 'Mark S.',
      location: 'Lake Nona, FL',
      testimonial: 'As a new pool owner, I was overwhelmed with maintenance. Splash Right not only handles everything expertly but has educated me on proper pool care. Their patience and willingness to answer all my questions has been invaluable.',
      rating: 5,
      date: 'August 2024'
    },
    {
      name: 'Jessica T.',
      location: 'Celebration, FL',
      testimonial: 'Our community recommended Splash Right for pool maintenance, and we\'re thrilled with their service. Professional, thorough, and reliable – exactly what we wanted in a pool service company!',
      rating: 5,
      date: 'July 2024'
    }
  ];

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="relative bg-purple-900 py-20">
        <div 
          className="absolute inset-0 z-0 opacity-30" 
          style={{
            backgroundImage: 'url("https://images.pexels.com/photos/261411/pexels-photo-261411.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2")',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="container mx-auto px-4 relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">What Our Customers Say</h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about our service.
          </p>
        </div>
      </section>

      {/* Featured Testimonial */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="bg-purple-50 rounded-lg shadow-xl p-8 border-l-4 border-orange-500 max-w-4xl mx-auto">
            <div className="flex items-start mb-6">
              <img 
                src="https://images.pexels.com/photos/774095/pexels-photo-774095.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
                alt="Rachel B."
                className="w-16 h-16 rounded-full object-cover mr-4"
              />
              <div>
                <h3 className="text-xl font-bold text-purple-900">Rachel B.</h3>
                <p className="text-gray-600">Homeowner in Orlando, FL</p>
                <div className="flex mt-1">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="h-5 w-5 text-orange-500 fill-orange-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                    </svg>
                  ))}
                </div>
              </div>
            </div>
            <blockquote className="text-xl text-gray-700 italic mb-6">
              "I can't say enough good things about Splash Right Pool Care. Their team has maintained our pool for two years, and it's always in perfect condition for our family to enjoy. Their first month free promotion got us started, but their exceptional service is why we've stayed. They're reliable, thorough, and truly care about customer satisfaction."
            </blockquote>
            <p className="text-gray-600">April 2025</p>
          </div>
        </div>
      </section>

      {/* All Testimonials */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-purple-900 mb-4">Customer Reviews</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              See what makes our pool cleaning service stand out from the rest.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard 
                key={index}
                name={testimonial.name}
                location={testimonial.location}
                testimonial={testimonial.testimonial}
                rating={testimonial.rating}
                date={testimonial.date}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Become a Customer */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-purple-900 mb-4">Join Our Satisfied Customers</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Experience the Splash Right difference for yourself. Contact us today for a free quote and take advantage of our special offer.
          </p>
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-6 max-w-2xl mx-auto mb-8">
            <p className="text-purple-900 font-semibold">
              <span className="text-orange-600 font-bold">Special Promotion:</span> First month of service FREE for new customers!
            </p>
          </div>
          <a
            href="/quote"
            className="inline-block px-6 py-3 bg-orange-500 text-white font-bold rounded-md hover:bg-orange-600 transition-colors duration-200"
          >
            Get Your Free Quote Today
          </a>
        </div>
      </section>

      <CallToAction />
    </div>
  );
};

export default TestimonialsPage;